import _find from 'lodash/find';

import template from './template.html';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      inventory: '=',
      venue: '=',
      onClick: '='
    },
    controller: [
      '$scope',
      ($scope) => {
        if (!$scope.inventory) throw new Error('inventory');
        if (!$scope.venue) throw new Error('venue');

        $scope.getSoldOutTiers = function() {
          if (!$scope.inventory || !$scope.inventory.tier || !$scope.inventory.tier.levels || !$scope.inventory.tier.levels.length) return [];

          const activeLevel = _find($scope.inventory.tier.levels, {
            _id: $scope.inventory.tier.activeLevel
          });
          const activeLevelIndex = $scope.inventory.tier.levels.indexOf(activeLevel);

          const levels = $scope.inventory.tier.levels.slice(0, activeLevelIndex).map(tier => {
            tier.name = $scope.inventory.name;
            return tier;
          });

          return levels.length > 1 ? levels.slice(Math.max(levels.length - 1, 1)) : levels;
        };

        $scope.onInventoryClicked = function($event) {
          if ($event) $event.preventDefault();

          if ($scope.onClick) {
            $scope.onClick($scope.inventory);
          }
        };
      }
    ]
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/inventoryListItem/index.js